import React, { useRef, useState } from 'react';
import { Trash2 } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';

export const DeleteMessageDialog = ({ message, onDelete, onClose, returnFocus, error }) => {
  const [busy, setBusy] = useState(false), [failed, setFailed] = useState(false);
  const sending = useRef(false);
  const confirm = async () => {
    if (sending.current) return;
    sending.current = true; setBusy(true); setFailed(false);
    try { if (await onDelete(message.id)) onClose(); else setFailed(true); }
    finally { sending.current = false; setBusy(false); }
  };
  return <Dialog open onOpenChange={(open) => { if (!open && !sending.current) onClose(); }}><DialogContent className="chat-clear-dialog" data-testid="chat-delete-dialog"
    onEscapeKeyDown={(event) => { if (busy) event.preventDefault(); }} onInteractOutside={(event) => event.preventDefault()}
    onCloseAutoFocus={(event) => { event.preventDefault(); returnFocus(); }}>
    <DialogTitle data-testid="chat-delete-title"><Trash2 size={20} />Delete message?</DialogTitle>
    <DialogDescription data-testid="chat-delete-description">Remove this message from {message.username} for everyone? This cannot be undone.{message.kind === 'tip' ? ' The tip transaction will not be affected.' : ''}</DialogDescription>
    {failed && <p role="alert" className="chat-error" data-testid="chat-delete-error">{error || 'Unable to delete the message. Please try again.'}</p>}
    <div className="chat-clear-actions"><Button variant="outline" disabled={busy} data-testid="chat-delete-cancel" onClick={onClose}>Cancel</Button><Button variant="destructive" disabled={busy} data-testid="chat-delete-confirm" onClick={confirm}><Trash2 size={16} />{busy ? 'Deleting…' : 'Delete message'}</Button></div>
  </DialogContent></Dialog>;
};